import { createClient } from '@supabase/supabase-js';

/**
 * Supabase client singleton. Env var resolution supports two naming
 * conventions because the app deploys to Cloudflare Pages (SUPABASE_*)
 * and also runs under Vite dev server (VITE_SUPABASE_*). Hardcoded
 * fallbacks are the production values -- safe because the publishable key
 * only allows RLS-scoped access.
 */
const supabaseUrl =
  import.meta.env.SUPABASE_URL ||
  import.meta.env.VITE_SUPABASE_URL ||
  'https://yyjdosiszdemxedysvls.supabase.co';

const supabasePublishableKey =
  import.meta.env.SUPABASE_PUBLISHABLE_KEY ||
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ||
  'sb_publishable_5vKm1TtFsqWRQM9VzGn7KQ_xdTev10w';

export const supabase = createClient(supabaseUrl, supabasePublishableKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});

// API base URL for edge functions
export const SUPABASE_FUNCTIONS_URL = `${supabaseUrl}/functions/v1`;
